export default "__VITE_ASSET__D5YucDwH__"